<template>
  <div
    class="flex flex-row items-center rounded  duration-300 transition py-1 pl-1 pr-2 leading-none gap-1 select-none"
    :class="{
      'bg-gray-roc text-white cursor-default': selected,
      'hover:bg-gray-100 cursor-pointer': !selected,
    }"
    @click="clicked"
  >
    <img
      :src="require(`@/assets/images/artifact/${group.icon}.png`)"
      alt=""
      class="w-8 h-8"
    />
    <span class="uppercase text-sm font-medium">
      {{ group.name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  emits: ['click'],
  setup (props, context) {
    return {
      clicked () {
        context.emit('click', props.group.id);
      }
    };
  }
};
</script>
